import React from 'react';
import { TextareaAutosize } from '@mui/material';

const TextareaAutosizeWithError = React.forwardRef(({ error, ...props }, ref) => {
  const style = {
    borderColor: error ? 'red' : '',
    width: '100%',
    minHeight: '100px',
    padding: '10px',
    fontSize: '16px',
    fontFamily: '"Roboto","Helvetica","Arial",sans-serif'
  };

  return (
    <TextareaAutosize {...props} ref={ref} style={style} />
  );
});

export default TextareaAutosizeWithError;